import _ from 'lodash'
import PrincipalFilter from 'scoreboard/reports/common/filter/principal-filter'
import AncestorFilter from 'scoreboard/reports/common/filter/ancestor-filter'
import CommonFilterMeta from 'scoreboard/reports/common/filter/common-filter-meta'
import TagFilter from 'scoreboard/reports/wizard/filter-meta/tag-filter'
import prettyInitiative from './pretty-initiative'
import { textFilterMeta } from 'scoreboard/reports/wizard/filter-meta/text-filter-meta'
import { multiChoiceMeta } from 'scoreboard/reports/wizard/filter-meta/multichoice'
import suggestionUrl from 'scoreboard/reports/common/filter/suggestion-url'
import enums from 'scoreboard/components/enums'
import currency from 'scoreboard/components/currency'
import NumericInitiativeCalculationsFilter from './numeric-initiative-calculations-filter'
import MultiChoiceInitiativeCalculationsFilter from './multichoice-initiative-calculations-filter'
import NumericFilter from 'scoreboard/reports/common/filter/numeric-filter'
import OrgFilter from 'scoreboard/reports/wizard/filter-meta/org-filter'
import dateFilterMeta from 'scoreboard/reports/common/filter/date-filter-meta'
import booleanFilterMeta from 'scoreboard/reports/common/filter/boolean-filter-meta'
import DataType from 'scoreboard/datasets/model/data-type'
const { CURRENCY, PERCENT } = DataType

function textFilter(nameCode, columnType) {
	let seedArgs = columnType ? [columnType, 'initiative'] : null
	return _.omit(textFilterMeta(nameCode, seedArgs), 'groupCode')
}

function multiChoiceFilter(nameCode, enumKeyOrFunc) {
	let choices = () => {
		return _.isFunction(enumKeyOrFunc) ? enumKeyOrFunc() : enums[enumKeyOrFunc]
	}
	return _.omit(multiChoiceMeta(nameCode, choices, 'groupCode'))
}

function numericInitiativeCalculationsFilter(nameCode, columnType) {
	return {
		nameCode,
		filterType: 'range-numeric',
		form: NumericInitiativeCalculationsFilter,
		seed: suggestionUrl(columnType, 'initiative'),
		dataType: 'number'
	}
}

function percentageInitiativeCalculationsFilter(nameCode, columnType) {
	return _.extend(numericInitiativeCalculationsFilter(nameCode, columnType), {
		dataType: PERCENT
	})
}

function currencyInitiativeCalculationsFilter(nameCode, columnType) {
	return _.extend(numericInitiativeCalculationsFilter(nameCode, columnType), {
		dataType: CURRENCY
	})
}

const InitiativeFilterMeta = _.extend({
	assignees: {
		nameCode: 'report.initiativeReport.form.user',
		assigneesInfo: {
			heading: 'report.initiativeReport.form.user',
			placeholder: 'report.initiativeReport.addAssignee'
		},
		filterType: 'id',
		form: PrincipalFilter
	},
	initiativeIds: {
		nameCode: 'report.initiativeReport.form.initiative',
		filterType: 'ancestor',
		form: AncestorFilter,
		formOptions: {
			autoSelectRoot: true,
			showFollowLinked: false,
			section: 'initiatives'
		},
		dialogType: 'dark',
		allowInlineDisplay: false,
		stringify: prettyInitiative
	},
	startDate: dateFilterMeta('initiatives.startDate'),
	dueDate: dateFilterMeta('initiatives.dueDate'),
	completionDate: dateFilterMeta('initiatives.completionDate'),
	archived: booleanFilterMeta('report.initiativeReport.form.archivestatus',
		'report.initiativeReport.archived',
		'report.initiativeReport.notArchived'),
	completed: booleanFilterMeta('report.initiativeReport.form.compstatus',
		'report.initiativeReport.completed',
		'report.initiativeReport.notCompleted'),
	label: textFilter('report.customReport.label', 'label'),
	description: textFilter('report.customReport.description'),
	type: multiChoiceFilter('initiatives.type', 'initiativeType'),
	currency: multiChoiceFilter('common.currency', () => currency.labelsByCode()),
	goalFunction: multiChoiceFilter('initiatives.goalFunction', 'goalFunction'),
	tagIds: {
		nameCode: 'report.customReport.tags',
		filterType: 'id',
		form: TagFilter,
		seed: 'api/tags'
	},
	colors: {
		nameCode: 'report.customReport.scorecardColor',
		filterType: 'range-multichoice',
		form: MultiChoiceInitiativeCalculationsFilter,
		choices: function() { return enums['initiativeColor'] }
	},
	totalBudget: {
		nameCode: 'initiatives.budget',
		filterType: 'numeric',
		form: NumericFilter,
		seed: suggestionUrl('aggregated-budget', 'initiative'),
		dataType: CURRENCY
	},
	percentComplete: percentageInitiativeCalculationsFilter('initiatives.percentComplete', 'percent-complete'),
	daysElapsed: numericInitiativeCalculationsFilter('initiatives.calculation.daysElapsed', 'days-elapsed'),
	percentTimeElapsed: numericInitiativeCalculationsFilter('report.designer.percentTimeElapsed', 'percent-time-elapsed'),
	projectedScheduleVariance: numericInitiativeCalculationsFilter('initiatives.calculation.projectedScheduleVariance', 'schedule-variance'),
	projectedEndDate: dateFilterMeta('initiatives.projectedEndDate'),
	budgetRemaining: currencyInitiativeCalculationsFilter('initiatives.budgetRemaining', 'budget-remaining'),
	projectedTotalBudget: currencyInitiativeCalculationsFilter('initiatives.calculation.projectedBudget', 'projected-budget'),
	projectedBudgetVariance: currencyInitiativeCalculationsFilter('initiatives.calculation.projectedBudgetVariance', 'budget-variance'),
	projectedBudgetVariancePercent: percentageInitiativeCalculationsFilter('initiatives.calculation.projectedBudgetVariancePercent', 'budget-variance-percent'),
	budgetSpentToDate:  currencyInitiativeCalculationsFilter('initiatives.calculation.budgetSpentToDate', 'budget-spent'),
	organizationIds: {
		nameCode: 'report.customReport.specificOrganizations',
		filterType: 'org',
		form: OrgFilter,
		dialogType: 'dark',
		allowInlineDisplay: false,
		groupCode: 'admin.scorecards.metric.scoringType.basic',
		section: 'initiatives'
	}
}, CommonFilterMeta)

export default InitiativeFilterMeta

InitiativeFilterMeta.__filename__ = 'reports/wizard/initiative-report/initiative-filter-meta.js'
